<template>
    <b-container>
        <b-row align-h="center">
            <b-col cols="12">
                <b-card class="shadow my-md-4 mt-4 mb-2">
                    <h4 class="text-center text-primary text-uppercase">
                        <u>Resumen: ID {{ details.id }}</u>
                    </h4>
                    <h5 class="text-center">Estado: {{ details.status_title }}</h5>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Datos del Destinatario</b-th>
                                <b-td stacked-heading="Nombres">{{ details.receiver.name }}</b-td>
                                <b-td stacked-heading="Apellidos">{{ details.receiver.lname ? (details.receiver.lname).replace(',', '') : '' }}</b-td>
                                <b-td stacked-heading="Documento">{{ details.receiver.td }} {{ details.receiver.nd }}</b-td>
                                <b-td stacked-heading="Email">{{ details.receiver.email }}</b-td>
                                <b-td stacked-heading="Teléfono">{{ details.receiver.mobile }}</b-td>
                                <b-td stacked-heading="Dirección">{{ details.receiver.address }} {{ details.receiver.district }}</b-td>
                                <b-td stacked-heading="Ciudad">{{ details.receiver.city }}</b-td>
                                <b-td stacked-heading="País">{{ details.country_receiver_text }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles de la Transacción</b-th>
                                <b-td stacked-heading="Sessión ID">{{ details.session_id }}</b-td>
                                <b-td stacked-heading="Fecha/Hora">{{ new Date((''+details.date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</b-td>
                                <b-td stacked-heading="Tipo de Pago">{{ details.payment_text }}</b-td>
                                <b-td stacked-heading="Valor Pagado">{{ Number(details.amount_send).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Comisión">{{ Number(details.fee).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Valor Enviado">{{ Number(details.amount_send - details.fee).toLocaleString("en-US") + ' ' + details.currency_send }}</b-td>
                                <b-td stacked-heading="Tasa de Conversión">{{details.rate < 1 ? Number(1/details.rate).toLocaleString("en-US", {maximumFractionDigits: 4}) : 1 }} {{ details.currency_send }} ► {{details.rate > 1 ? Number(details.rate).toLocaleString("en-US", {maximumFractionDigits: 4}) : 1 }} {{ details.currency_receiver }}</b-td>
                                <b-td stacked-heading="Valor Recibido">{{ Number(details.amount_receiver).toLocaleString("en-US") + ' ' + details.currency_receiver }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col cols="12" md="6" class="pb-md-4 py-2">
                <b-card class="shadow h-100">
                    <b-table-simple stacked>
                        <b-tbody>
                            <b-tr>
                                <b-th class="text-center border-top-0">Detalles de Pago</b-th>
                                <b-td stacked-heading="Convenio" v-if="details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-')">{{ ((details.pin).split('-'))[0] }}</b-td>
                                <b-td stacked-heading="PIN">{{ details.pin !== null && details.country_receiver === 'CO' && (details.pin).includes('-') ? ((details.pin).split('-'))[1] : details.pin }}</b-td>
                                <b-td stacked-heading="Banco" v-if="details.destiny_pay === 'Bank'">{{ details.bank_info.name }}</b-td>
                                <b-td stacked-heading="Oficina" v-else>{{ details.office_info.name + ' (' + details.office_info.payer + ')' }}</b-td>
                                <b-td stacked-heading="Teléfono" v-if="details.destiny_pay === 'Cash'">{{ details.office_info.phone }}</b-td>
                                <b-td stacked-heading="Dirección" v-if="details.destiny_pay === 'Cash'">{{ details.office_info.address + ', ' + details.office_info.city + (details.office_info.state !== null ? ' - ' + details.office_info.state : '') }}</b-td>
                                <b-td stacked-heading="Horario" v-if="details.destiny_pay === 'Cash'">{{ details.office_info.open }}</b-td>
                                <b-td :stacked-heading="'Cuenta ' + (details.receiver.tc === 'Ahorros' ? 'de ' : '') + details.receiver.tc" v-else>{{ details.receiver.nc }}</b-td>
                                <b-td stacked-heading="CBU" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'AR'">{{ details.receiver.details.cbu }}</b-td>
                                <b-td stacked-heading="CPF" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'BR'">{{ details.receiver.details.cpf }}</b-td>
                                <b-td stacked-heading="Agencia Bancaria" v-if="details.destiny_pay === 'Bank' && details.country_receiver === 'BR'">{{ details.receiver.details.nab }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Result",
    props: [ 'user' ],
    data: () => ({
        loading: true,
        details: {
            id: '',
            pin: '',
            session_id: '',
            receiver: {
                name: '',
                lname: '',
                td: '',
                nd: '',
                email: '',
                mobile: '',
                bank: '',
                tc: '',
                nc: '',
                address: '',
                district: '',
                city: '',
                state: ''
            },
            country_receiver_text: '',
            destiny_pay: '',
            office_info: {
                name: '',
                payer: ''
            },
            bank_info: {
                name: ''
            },
            amount_send: '',
            currency_send: '',
            fee: '',
            fx_rate: '',
            amount_receiver: '',
            currency_receiver: '',
            payment: '',
            payment_text: '',
            status_title: ''
        }
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'resultpage');
        this.getIni();
        const msg = this.$route.query.msg || null;
        const status = this.$route.query.status || null;
        if (msg && status) {
            this.getMsg(msg, status);
            this.$router.replace({ query: {} });
        }
    },
    methods: {
        getIni() {
            axios.get('/api/customer/request/result').then((res) => {
                if (res.data.status === 'success') {
                    this.details = res.data.item;
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.$router.push({ name: 'Request' });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        },
        getMsg(msg, status) {
            this.$root.$bvToast.toast(msg, {
                title: 'Notificación',
                headerClass: 'd-none',
                variant: status,
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
        }
    }
}
</script>

<style scoped>

</style>
